import React from "react";
import { Box, IconButton, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

interface NumberInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  min?: number;
  max?: number;
}

const NumberInput: React.FC<NumberInputProps> = ({
  label,
  value,
  onChange,
  required,
  error,
  helperText,
  min = 0,
  max = Infinity,
}) => {
  const handleIncrement = () => {
    const numValue = parseInt(value) || 0;
    if (numValue < max) {
      onChange((numValue + 1).toString());
    }
  };

  const handleDecrement = () => {
    const numValue = parseInt(value) || 0;
    if (numValue > min) {
      onChange((numValue - 1).toString());
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const numValue = parseInt(newValue);
    if (
      newValue === "" ||
      (!isNaN(numValue) && numValue >= min && numValue <= max)
    ) {
      onChange(newValue);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton
        onClick={handleDecrement}
        disabled={parseInt(value) <= min}
        size="small"
      >
        <RemoveIcon />
      </IconButton>
      <TextField
        label={label}
        value={value}
        onChange={handleChange}
        required={required}
        error={error}
        helperText={helperText}
        size="small"
        sx={{ width: "80px", mx: 1 }} // Changed from minWidth: "120px" to width: "80px"
        inputProps={{ style: { textAlign: "center" } }}
      />
      <IconButton
        onClick={handleIncrement}
        disabled={parseInt(value) >= max}
        size="small"
      >
        <AddIcon />
      </IconButton>
    </Box>
  );
};

export default NumberInput;
